// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-mgmt-dialog {
  max-width: 600px !important;
  /* height: 80%; */
}

.modal-content {
  height: 100%;
}

.modal-body {
  height: 80%;
}

.user-group-title-div {
  display: flex;
  /* line-height: 30px; */
  margin-bottom: 10px;
}

.ta-add-button-right {
  margin-left: auto !important;
}

.input-label {
  font-size: 12px;
}

.tri-state-group-list {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  border: 1px solid #babfc7;
  border-radius: 2px;
  background: #fff;
}

.tri-state-group-row {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border-bottom: 1px solid #dde2eb;
  cursor: pointer;
  font-size: 13px;
  margin: 0;
}

.tri-state-group-row:last-child {
  border-bottom: none;
}

.tri-state-group-row:hover {
  background-color: #f5f7f7;
}

.tri-state-checkbox {
  -webkit-appearance: none;
  appearance: none;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  flex-shrink: 0;
  background: #fff;
  border: 1px solid #999999;
  border-radius: 2px;
  cursor: pointer;
}

.tri-state-checkbox:checked,
.tri-state-checkbox:indeterminate {
  border-color: #2196f3;
}

.tri-state-checkbox:checked::after {
  content: "";
  width: 5px;
  height: 9px;
  margin-bottom: 1px;
  border: solid #2196f3;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.tri-state-checkbox:indeterminate::after {
  content: "";
  width: 9px;
  height: 2px;
  background: #2196f3;
}

.tri-state-group-name {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/userManagement/components/style.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".user-mgmt-dialog {\n  max-width: 600px !important;\n  /* height: 80%; */\n}\n\n.modal-content {\n  height: 100%;\n}\n\n.modal-body {\n  height: 80%;\n}\n\n.user-group-title-div {\n  display: flex;\n  /* line-height: 30px; */\n  margin-bottom: 10px;\n}\n\n.ta-add-button-right {\n  margin-left: auto !important;\n}\n\n.input-label {\n  font-size: 12px;\n}\n\n.tri-state-group-list {\n  height: 100%;\n  width: 100%;\n  overflow-y: auto;\n  border: 1px solid #babfc7;\n  border-radius: 2px;\n  background: #fff;\n}\n\n.tri-state-group-row {\n  display: flex;\n  align-items: center;\n  padding: 6px 10px;\n  border-bottom: 1px solid #dde2eb;\n  cursor: pointer;\n  font-size: 13px;\n  margin: 0;\n}\n\n.tri-state-group-row:last-child {\n  border-bottom: none;\n}\n\n.tri-state-group-row:hover {\n  background-color: #f5f7f7;\n}\n\n.tri-state-checkbox {\n  -webkit-appearance: none;\n  appearance: none;\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n  flex-shrink: 0;\n  background: #fff;\n  border: 1px solid #999999;\n  border-radius: 2px;\n  cursor: pointer;\n}\n\n.tri-state-checkbox:checked,\n.tri-state-checkbox:indeterminate {\n  border-color: #2196f3;\n}\n\n.tri-state-checkbox:checked::after {\n  content: \"\";\n  width: 5px;\n  height: 9px;\n  margin-bottom: 1px;\n  border: solid #2196f3;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.tri-state-checkbox:indeterminate::after {\n  content: \"\";\n  width: 9px;\n  height: 2px;\n  background: #2196f3;\n}\n\n.tri-state-group-name {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
